exports = module.exports = require("../../../../react/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2dq{display:-webkit-box;display:flex;background:var(--cyan);height:60px;width:100%;box-sizing:border-box;-webkit-box-pack:center;justify-content:center}._2dq._1Fy{position:-webkit-sticky;position:sticky;top:0;z-index:3}._2dq ._31h{box-sizing:border-box;max-width:var(--layoutWidth,980px);height:100%;width:100%;padding:0 20px}@media screen and (min-width:1020px){._31h{padding:0!important}}", ""]);
// Exports
exports.locals = {
	"navbar": "_2dq",
	"sticky": "_1Fy",
	"container": "_31h"
};